const sharePopupOpenTarget = '.wm-shareOpenPopup';
const sharePopupCloseTarget = 'div.wm-popup__shareCloseButton > i';
const shareButtonTarget = 'div.wm-popup__shareLink > button';
const shareTooltipTarget = 'div.wm-popup__shareLink > .wm-tooltipText';
const shareLinkTarget = 'div.wm-popup__shareLink > .wm-shareLinkOverlay';
const dataShareLinkTarget = 'a.wm-dataShareLink';
const activeChapterTarget = 'a.-activeChapter';
jQuery(document).on('ready', function () {
    var sharePopup = document.getElementById("sharePopup");
    var shareChapterPopup = document.getElementById("shareChapterPopup");
    var sharePostPopup = document.getElementById("sharePostPopup");
    if (jQuery(sharePopup).length > 0) {
        var currentURL = window.location.href.split('#')[0];
    }
    else if (jQuery(shareChapterPopup).length > 0) {
        var currentURL = window.location.href.split('#')[0];
        var currentActiveChapterHref = jQuery(activeChapterTarget).attr('href');
        if (typeof currentActiveChapterHref !== "undefined") {
            currentURL = currentURL + currentActiveChapterHref;
        }
    }
    if (jQuery(shareChapterPopup).length > 0 || jQuery(sharePopup).length > 0) {
        var shareLink = document.getElementById("shareLink");
        shareLink.value = currentURL;
        jQuery(shareTooltipTarget).hide(1);
        var mailShareLink = document.getElementById("mailShareLink");
        mailShareLink.setAttribute('href', "mailto:?body=" + currentURL);
        var facebookShareLink = document.getElementById("facebookShareLink");
        facebookShareLink.setAttribute('href', "https://www.facebook.com/share.php?u=" + encodeURIComponent(currentURL));
        var twitterShareLink = document.getElementById("twitterShareLink");
        twitterShareLink.setAttribute('href', "https://twitter.com/intent/tweet?url=" + encodeURIComponent(currentURL));
        var linkedinShareLink = document.getElementById("linkedinShareLink");
        linkedinShareLink.setAttribute('href', "https://www.linkedin.com/shareArticle?url=" + encodeURIComponent(currentURL));
        var whatsappShareLink = document.getElementById("whatsappShareLink");
        whatsappShareLink.setAttribute('href', "https://wa.me/?text=" + encodeURIComponent(currentURL));
    }
    else if (jQuery(sharePostPopup).length > 0) {
        var shareLink = document.getElementById("shareLink");
        shareLink.value = "";
    }
    jQuery(sharePopupOpenTarget).on('click', function (e) {
        e.preventDefault();
        if (jQuery(sharePopup).length > 0) {
            sharePopup.classList.toggle("-show");
        }
        else if (jQuery(shareChapterPopup).length > 0) {
            shareChapterPopup.classList.toggle("-show");
            var newCurrentURL = window.location.href.split('#')[0];
            var newCurrentActiveChapterHref = jQuery(activeChapterTarget).attr('href');
            if (typeof newCurrentActiveChapterHref !== "undefined") {
                newCurrentURL = newCurrentURL + newCurrentActiveChapterHref;
            }
            if (currentURL != newCurrentURL) {
                currentURL = newCurrentURL;
                shareLink.value = currentURL;
                var mailShareLink = document.getElementById("mailShareLink");
                mailShareLink.setAttribute('href', "mailto:?body=" + currentURL);
                var facebookShareLink = document.getElementById("facebookShareLink");
                facebookShareLink.setAttribute('href', "https://www.facebook.com/share.php?u=" + encodeURIComponent(currentURL));
                var twitterShareLink = document.getElementById("twitterShareLink");
                twitterShareLink.setAttribute('href', "https://twitter.com/intent/tweet?url=" + encodeURIComponent(currentURL));
                var linkedinShareLink = document.getElementById("linkedinShareLink");
                linkedinShareLink.setAttribute('href', "https://www.linkedin.com/shareArticle?url=" + encodeURIComponent(currentURL));
                var whatsappShareLink = document.getElementById("whatsappShareLink");
                whatsappShareLink.setAttribute('href', "https://wa.me/?text=" + encodeURIComponent(currentURL));
            }
        }
    });
    jQuery(document).on('click', dataShareLinkTarget, function (e) {
        e.preventDefault();
        if (jQuery(sharePostPopup).length > 0) {
            var shareURL = jQuery(this).data("share-link");
            shareLink.value = shareURL;
            jQuery(shareTooltipTarget).hide(1);
            var mailShareLink = document.getElementById("mailShareLink");
            mailShareLink.setAttribute('href', "mailto:?body=" + shareURL);
            var facebookShareLink = document.getElementById("facebookShareLink");
            facebookShareLink.setAttribute('href', "https://www.facebook.com/share.php?u=" + encodeURIComponent(shareURL));
            var twitterShareLink = document.getElementById("twitterShareLink");
            twitterShareLink.setAttribute('href', "https://twitter.com/intent/tweet?url=" + encodeURIComponent(shareURL));
            var linkedinShareLink = document.getElementById("linkedinShareLink");
            linkedinShareLink.setAttribute('href', "https://www.linkedin.com/shareArticle?url=" + encodeURIComponent(shareURL));
            var whatsappShareLink = document.getElementById("whatsappShareLink");
            whatsappShareLink.setAttribute('href', "https://wa.me/?text=" + encodeURIComponent(shareURL));
            sharePostPopup.classList.toggle("-show");
        }
    });
    jQuery(document).on('click', sharePopupCloseTarget, function () {
        if (jQuery('#sharePopup.-show').length > 0) {
            sharePopup.classList.toggle("-show");
        }
        else if (jQuery('#shareChapterPopup.-show').length > 0) {
            shareChapterPopup.classList.toggle("-show");
        }
        else if (jQuery('#sharePostPopup.-show').length > 0) {
            sharePostPopup.classList.toggle("-show");
        }
    });
    jQuery(document).on('click', shareLinkTarget, function () {
        shareLink.select();
        shareLink.setSelectionRange(0, 99999);
        navigator.clipboard.writeText(shareLink.value);
        jQuery(shareTooltipTarget).show(1).delay(5000).hide(1);
    });
    jQuery(document).on('click', shareButtonTarget, function () {
        shareLink.select();
        shareLink.setSelectionRange(0, 99999);
        navigator.clipboard.writeText(shareLink.value);
        jQuery(shareTooltipTarget).show(1).delay(5000).hide(1);
    });
});
